import { IService, ServiceTypes } from '@types';

export function separateServices(services: IService[]) {
  const additional = filterAdditionalServices(services);
  return {
    additional,
    main: filterValidMainServices(filterMainServices(services))
      .map((service) => {
        service.additionalServices = service.additionalEnableServices
          // ?.filter(({ isEnable }) => isEnable)
          ?.filter(({ childrenId: id }) => additional.some(s => s.id === id))
          .map(aes => {
            const additionalService = additional.find(({ id }) => id === aes.childrenId) || {};
            return {
              ...additionalService,
              isEnable: aes.isEnable,
              isRequire: aes.isRequire,
              customerCanView: aes.customerCanView,
            };
          })
          .filter((el) => {
            const { isValid, customerCanView, isRequire } = el;
            return (isValid && (customerCanView || isRequire));
          });
          delete service.additionalEnableServices;
          return service;
        }
      )
  };
}

function filterValidMainServices(services: IService[]) {
  return services
    .filter(s => s.isValid && (s.customerCanView || s.isRequire))
    .sort((a, b) => a.sortPosition - b.sortPosition);
}

export function filterMainServices(services: IService[]) {
  return services.filter(s => s.type !== ServiceTypes.Additional);
}

export function filterAdditionalServices(services: IService[]) {
  return services.filter(s => s.type === ServiceTypes.Additional);
}
